/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { pkg } from '../../settings';
import useNestedRowExpander from './useNestedRowExpander';
var blockClass = "".concat(pkg.prefix, "--datagrid");

var useNestedRows = function useNestedRows(hooks) {
  useNestedRowExpander(hooks);
  var marginLeft = 24;

  var getRowProps = function getRowProps(props, _ref) {
    var row = _ref.row;
    return [props, {
      className: row.depth > 0 ? "".concat(blockClass, "__carbon-nested-row") : ''
    }];
  };

  var getRowStyles = function getRowStyles(props, _ref2) {
    var row = _ref2.row;
    return [props, {
      style: {
        marginLeft: "".concat(row.depth > 0 ? marginLeft : 0, "px"),
        paddingLeft: "".concat(row.depth > 1 ? marginLeft * (row.depth - 1) + marginLeft : row.depth === 1 ? marginLeft : 0, "px"),
        maxWidth: "calc(100% - ".concat(marginLeft * row.depth, "px)")
      }
    }];
  };

  var getCellProps = function getCellProps(props, _ref3) {
    var cell = _ref3.cell,
        instance = _ref3.instance;
    // reduce the "first cell"s width to compensate added (left) margin
    var isFirstCell = instance.columns.findIndex(function (c) {
      return c.id === cell.column.id;
    }) === 0;
    return [props, {
      style: {
        marginRight: "".concat(isFirstCell && cell.row.depth > 0 ? "-".concat(marginLeft * (cell.row.depth + 1), "px") : '')
      }
    }];
  };

  hooks.getRowProps.push(getRowProps);
  hooks.getRowProps.push(getRowStyles);
  hooks.getCellProps.push(getCellProps);
};

export default useNestedRows;